<ng-container *transloco="let t; read 'admin-pages.dashboard.table';">
  <div class="flex justify-center text-blue1">
    <div class="flex gap-4">
      <div class="text-2xl font-bold">
        lat: {{ locationData.lat | number:'0.0-2' }}
      </div>
      <div class="text-2xl font-bold">
        lng: {{ locationData.lng | number:'0.0-2' }}
      </div>
    </div>
  </div>

  <!--  t(admin-pages.dashboard.table.lat, admin-pages.dashboard.table.lng, admin-pages.dashboard.table.annual-co2-reduction, admin-pages.dashboard.table.investment, admin-pages.dashboard.table.investment-return, admin-pages.dashboard.table.system-capacity)  -->
  <ngx-datatable
    [messages]="{emptyMessage: 'no_data_in_table' | transloco}"
    class="material"
    [rows]="locationData.statistics"
    [columnMode]="ColumnMode.force"
    [footerHeight]="50"
    [rowHeight]="50"
    [headerHeight]="50">
    <ngx-datatable-column
      *ngFor="let column of basicColumns"
      [name]="t(column.translationKey)"
      [prop]="column.prop">
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{ value ? (value | number:'0.0-2') : '-' }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      [name]="t('user-contact')"
      [pipe]="fillIfEmptyValuePipe"
      prop="userContact">
    </ngx-datatable-column>

  </ngx-datatable>

</ng-container>
